export default __webpack_public_path__ + "static/media/tabor-csoport-ujkep.f6e3840d.png";